var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.7261C4 11.3464 4.28215 11.0326 4.64823 10.9829L4.75 10.9761H19.75C20.1642 10.9761 20.5 11.3119 20.5 11.7261C20.5 12.1058 20.2178 12.4196 19.8518 12.4692L19.75 12.4761L4.75 12.4761C4.33579 12.4761 4 12.1403 4 11.7261Z",
    fill: "#005AE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.17 6.23296C12.8765 5.9407 12.8755 5.46582 13.1677 5.1723C13.4334 4.90546 13.8501 4.88036 14.1441 5.09758L14.2284 5.17002L20.2784 11.194C20.546 11.4605 20.5704 11.8786 20.3514 12.1727L20.2784 12.2569L14.2284 18.2819C13.935 18.5742 13.4601 18.5732 13.1678 18.2797C12.9021 18.0129 12.8787 17.5962 13.0972 17.303L13.17 17.2191L18.686 11.7252L13.17 6.23296Z",
    fill: "#005AE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.d1bcb07f.svg";
export { ForwardRef as ReactComponent };